import { render, staticRenderFns } from "./ModalCreateNewPersonalizationSet.vue?vue&type=template&id=5a23f2ae&scoped=true"
import script from "./ModalCreateNewPersonalizationSet.vue?vue&type=script&lang=js"
export * from "./ModalCreateNewPersonalizationSet.vue?vue&type=script&lang=js"
import style0 from "./ModalCreateNewPersonalizationSet.vue?vue&type=style&index=0&id=5a23f2ae&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a23f2ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a23f2ae')) {
      api.createRecord('5a23f2ae', component.options)
    } else {
      api.reload('5a23f2ae', component.options)
    }
    module.hot.accept("./ModalCreateNewPersonalizationSet.vue?vue&type=template&id=5a23f2ae&scoped=true", function () {
      api.rerender('5a23f2ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/personalization/ModalCreateNewPersonalizationSet.vue"
export default component.exports